import styled from 'styled-components';

import { media } from '@theme/media';
import { COLORS } from '@theme/colors';

export const InputWrapper = styled.div`
  display: flex;
  margin: 0 0 17px;
  position: relative;
`;

export const Input = styled.input`
  appearance: none;
  background-color: transparent;
  border: 1px solid ${COLORS.BLACK};
  box-shadow: none;
  padding: 0;
  width: 24px;
  height: 12px;
  border-radius: 6px;
  flex-shrink: 0;
  display: inline-block;
  position: relative;
  margin: 0 10px 0 0;

  &:after {
    content: '';
    position: absolute;
    top: 1px;
    left: 1px;
    background-color: transparent;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: block;
    border: 1px solid ${COLORS.BLACK};
    transition: transform 0.2s ease-in-out;
  }

  &:checked {
    background-color: ${COLORS.BLACK};
    box-shadow: none;
    order: 1;

    &:after {
      transform: translate3d(12px, 0, 0);
      background-color: ${COLORS.WILD_SAND};
      border-color: ${COLORS.WILD_SAND};
    }
  }

  ${media.mobile} {
    margin: 4px 10px 0 0;
    width: 20px;
    height: 10px;
    border-radius: 5px;

    &:after {
      width: 4px;
      height: 4px;
    }

    &:checked {
      &:after {
        transform: translate3d(10px, 0, 0);
      }
    }
  }
`;

export const Caption = styled.div`
  order: 2;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.02em;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: row;
  background-color: ${COLORS.WILD_SAND};
  width: 100%;
  padding: 17px 10px 14px;

  ${media.tablet} {
    padding: 9px 14px 7px;
  }

  ${Caption} a {
    text-decoration: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  }
`;
